export default __webpack_public_path__ + "static/media/justrain primary.de7f47dc.jpg";